import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  setup(__props) {

return { __sfc: true, }
}

})